import script from "./PlanogramViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanogramViewer.vue?vue&type=script&setup=true&lang=js"

import "./PlanogramViewer.vue?vue&type=style&index=0&id=051a1fce&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051a1fce"]])

export default __exports__